export default "__VITE_ASSET__Catx1Zyo__"